import React from "react";
import "./WalletActions.css";
import { Link } from "react-router-dom";

function WalletActions() {
  return (
    <>
      <section className="WalletActions">
        <div className="wallet-actions">
          <div className="action-box">
          <Link to={"/deposite"}>
            <div className="icon">
              <div className="icon_box ">
                <img
                  src={"/assets/images/icons/wallet.png"}
                  alt="invitation"
                  className="icon_img"
                />
              </div>
            </div>
            <p>Deposit</p>
          </Link>
          </div>
          <div className="action-box">
          <Link to={"/withdraw"}>
            <div className="icon">
              <div className="icon_box ">
                <img
                  src={"/assets/images/icons/credit_card.png"}
                  alt="invitation"
                  className="icon_img"
                />
              </div>
            </div>
            <p>Withdraw</p>
          </Link>
          </div>

          <div className="action-box">
          <Link to={"/vip"}>
            <div className="icon">
              <div className="icon_box ">
                <img
                  src={"/assets/images/icons/vip.png"}
                  alt="invitation"
                  className="icon_img"
                />
              </div>
            </div>
            <p>VIP</p>
          </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default WalletActions;
